<template lang="pug">
  .work-box(:class="{'in-detail' : work.inDetail }")
    .work-img(:style="{ backgroundImage: 'url(' + work.workImg + ')' }")
    .work-gradient
    .work-texts
      .work-info
        p {{work.workInfo}}
      .work-title
        .work-title-en
          p {{work.workTitle.en}}
        .work-title-zh(v-if="work.workTitle.zh")
          p {{work.workTitle.zh}}
</template>

<script>
export default {
  name: 'WorkBox',
  props: ['work'],
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="sass" scoped>
  $breakpoint: 1000px

  .link
    width: 100%

  .work-box
    width: 100%
    border: 1px solid #fff
    margin-bottom: 40px
    font-weight: bold
    overflow: hidden
    background-color: #000
    @media screen and (min-width: 600px)
      &:hover
        .work-img
          transform: translate(-50%,-50%) scale(1.05)
        .work-gradient
          opacity: 0.8

    &:before
      content: ""
      display: block
      padding-top: 56.25%
    .work-img
      position: absolute
      top: 50%
      left: 50%
      width: 100%
      height: 100%
      background-size: cover
      background-position: 50% 50%
      transform: translate(-50%,-50%)
      transition: transform 0.3s
    .work-gradient
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: linear-gradient(0deg, rgba(#707070,1), rgba(#707070,0), rgba(#707070,0))
      transition: opacity 0.3s
      mix-blend-mode: multiply
    .work-texts
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      padding: 20px
      display: flex
      flex-direction: column
      align-items: flex-start
      justify-content: flex-end
      color: #000
      line-height: 1.4
      @media screen and (max-width: 600px)
        padding: 10px
      ::selection
        background: #000
        color: #fff
      .work-info
        font-size: 20px
        margin-bottom: 5px
        @media screen and (max-width: 600px)
          font-size: 12px
        p
          background-color: #fff
          display: inline
      .work-title
        font-size: 50px
        display: flex
        flex-direction: column
        align-items: flex-start
        @media screen and (max-width: 600px)
          font-size: 20px
        .work-title-en
          p
            background-color: #fff
            display: inline
        .work-title-zh
          font-weight: normal
          p
            background-color: #fff
            display: inline
    @media screen and (max-width: 600px)
      margin-bottom: 20px
    &.in-detail
      &:hover
        .work-img
          transform: translate(-50%,-50%)
        .work-gradient
          opacity: 1
      @media screen and (max-width: 600px)
        height: 100%
        &:before
          display: none
</style>



// WEBPACK FOOTER //
// src/components/WorkBox.vue